export const buildQueryString = (params: Record<string, any>, splitArrayParams = false) => {
  const paramsKeys = Object.keys(params);
  return paramsKeys.reduce(
    (out, k) => {
      if (params[k] !== undefined && params[k] !== null) {
        if (splitArrayParams && Array.isArray(params[k])) {
          params[k].forEach((value: string | number | boolean) => {
            out += `${k}[]=${encodeURIComponent(value)}&`;
          });
        } else {
          out += `${k}=${encodeURIComponent(params[k])}&`;
        }
      }

      return out;
    },
    paramsKeys.length ? '?' : '',
  );
};
